import axios from 'axios';
import toast from 'react-hot-toast';

import { apiUrl } from '../apiUrl';

export const fetchOneTimeWorkshops = async ({ franchiseId }) => {
  try {
    const response = await axios.get(
      `${apiUrl}/newSummerplay/${franchiseId}/one_time_workshops`,
    );

    return response.data.summerplay_groups || [];
  } catch (error) {
    toast.error(
      'Wystąpił problem pobierania grup półkolonii. Odśwież aplikację.',
    );

    return [];
  }
};
